/** Carpetas estáticas bajo /gac/ (no son “tipos” de vehículos de la SPA). */
export const STATIC_LANDING_SLUGS = ["aion-ut", "aion"];

export const isStaticLandingSlug = (tipo) =>
  typeof tipo === "string" && STATIC_LANDING_SLUGS.includes(tipo);

/**
 * Si la SPA atrapó un slug estático, fuerza full-page a /gac/{slug}/
 * para que Apache sirva la carpeta (no el index de React).
 * @returns {boolean} true → no redirigir a /todos
 */
export const handleStaticLandingCapture = (tipo, search = "") => {
  if (!isStaticLandingSlug(tipo)) return false;

  // Ya estamos en el HTML estático de la landing AION
  if (typeof document !== "undefined" && document.querySelector("x-dc, script[data-dc-script]")) {
    return true;
  }

  const qs = search || (typeof window !== "undefined" ? window.location.search : "") || "";
  const target = `/gac/${tipo}/${qs}`;

  // Full page: deja que Apache sirva /gac/aion-ut/
  window.location.replace(target);
  return true;
};
